import { LoggerFactory } from "./logger";

export class TimeMeasure {
  static log<T>(name: string, procedure: () => T, description?: string, logger?: (m: string) => void): T {
    const _logger = logger
      ? logger
      : TimeMeasure.info;
    try {
      _logger(name + "開始." + (description ? description : ""));
      const started = TimeMeasure.getTimeStamp();
      const result = procedure();
      const finished = TimeMeasure.getTimeStamp();
      _logger(name + "終了.所要時間:" + (finished - started) + "msec");
      return result;
    } catch (e) {
      _logger(name + "異常終了.");
      throw e;
    }
  }

  static async logAsync<T>(name: string, procedure: () => Promise<T>, description?: string, logger?: (m: string) => void): Promise<T> {
    const _logger = logger
      ? logger
      : TimeMeasure.info;
    try {
      _logger(name + "開始." + (description ? description : ""));
      const started = TimeMeasure.getTimeStamp();
      const result = await procedure();
      const finished = TimeMeasure.getTimeStamp();
      _logger(name + "終了.所要時間:" + (finished - started) + "msec");
      return result;
    } catch (e) {
      _logger(name + "異常終了.");
      throw e;
    }
  }

  static getTimeStamp(): number {
    return (new Date()).getTime();
  }

  private static readonly _defaultLogger = LoggerFactory.getLogger();

  static info(m: string): void {
    TimeMeasure._defaultLogger.info(m);
  }

  static debug(m: string): void {
    TimeMeasure._defaultLogger.debug(m);
  }

  static trace(m: string): void {
    TimeMeasure._defaultLogger.trace(m);
  }

  static off(m: string): void {
    // 何も出力しない.
  }
}
